// import { Fonts } from 'react-bootstrap-icons';
// import PaperTemp from './PaperTemplate';
import { HashLink } from 'react-router-hash-link';

function MainTable() {
  return (
    <div className="container row">
      {/* <table
        style={{ marginTop: '-10px', width: '100%', borderStyle: 'none' }}
        className="table table-border_less caption-top"
      > */}
      <caption
        style={{
          fontSize: 26,
          fontWeight: 'bold',
          backgroundColor: 'lightgray',
          marginBottom: 10,
        }}
      >
        What you should know before applying
      </caption>
      {/* <tbody> */}
      {/* <tr> */}
      {/* <td> */}
      <div
        style={{ padding: 15, marginBottom: 25, backgroundColor: '#F2FFFF' }}
      >
        <p style={{ marginBottom: -2, fontSize: '14px' }}>
          <HashLink smooth to="#eligible">
            Parking Eligibility
          </HashLink>
        </p>
        <p style={{ marginBottom: -2, fontSize: '14px' }}>
          <HashLink smooth to="#applications">
            Parking Application
          </HashLink>
        </p>
        <p style={{ marginBottom: -2, fontSize: '14px' }}>
          <HashLink smooth to="#policy">
            One Employee One Account Policy
          </HashLink>
        </p>
        <p style={{ marginBottom: -2, fontSize: '14px' }}>
          <HashLink smooth to="#usage">
            Parking Usage Policy
          </HashLink>
        </p>
        <p style={{ marginBottom: -2, fontSize: '14px' }}>
          <HashLink smooth to="#deduction">
            Payroll Deductions
          </HashLink>
        </p>
        <p style={{ marginBottom: -2, fontSize: '14px' }}>
          <HashLink smooth to="#pmt-methods">
            Other Payment Methods
          </HashLink>
        </p>
        <p style={{ marginBottom: -2, fontSize: '14px' }}>
          <HashLink smooth to="#non-employee">
            Non-Employees Policy
          </HashLink>
        </p>
        <p style={{ marginBottom: -2, fontSize: '14px' }}>
          <HashLink smooth to="#cancellationId">
            Account Cancellation
          </HashLink>
        </p>
        <p style={{ marginBottom: -2, fontSize: '14px' }}>
          <HashLink smooth to="#act-changes">
            Account Information Changes
          </HashLink>
        </p>
        <p style={{ marginBottom: -2, fontSize: '14px' }}>
          <HashLink smooth to="#contactsId">
            Contact Us
          </HashLink>
        </p>
      </div>

      {/* </td> */}
      {/* <td> */}
      <p style={{ marginTop: 0 }}>
        <h6
          style={{
            textDecoration: 'underline',
            fontWeight: 'bold',
            marginBottom: 0,
          }}
        >
          Parking Eligibility
        </h6>
        <span style={{ fontSize: '16px' }}>
          Only NYP, Cornell Medicine and Columbia University Medical employees
          are eligible to apply for a parking monthly account. The presence of
          waiting lists does not guarantee the availability of space.
          Assignments from the waiting lists are determined by the date on which
          the monthly application is received.
        </span>
      </p>
      {/* </td> */}
      {/* <td> */}

      <h6
        style={{
          textDecoration: 'underline',
          fontWeight: 'bold',
          marginBottom: 0,
        }}
      >
        Parking Applications
      </h6>
      <span style={{ fontSize: '16px' }}>
        <p>
          Parking Department only accepts the online monthly application. All
          other monthly account applications are no longer accepted. Click{' '}
          <span style={{ fontWeight: 'bold' }}>
            <a href="https://app.smartsheet.com/b/form/481e30a27a234286a8d952537fba8e39">
              here
            </a>{' '}
          </span>
          to apply for a monthly parking account.
        </p>
      </span>

      {/* </td> */}
      {/* <td> */}
      <h6
        id="policy"
        style={{
          textDecoration: 'underline',
          fontWeight: 'bold',
          marginBottom: 0,
        }}
      >
        One Employee One Account Policy
      </h6>

      <span style={{ fontSize: '16px' }}>
        <p>
          The NYP Parking Department maintains the "One Employee, One Account"
          policy. Only the account registered owner is allowed to park in the
          garage to which the employee has been assigned. If anyone other than
          the account owner drives a monthly registered vehicle, daily parking
          fees will apply.
        </p>
      </span>
      {/* </td> */}
      {/* <td> */}
      <h6
        id="usage"
        style={{
          textDecoration: 'underline',
          fontWeight: 'bold',
          marginBottom: 0,
        }}
      >
        Parking Usage Policy
      </h6>
      <span style={{ fontSize: '16px' }}>
        <p>
          The NYP Parking Department follows the "One Account, One Garage" rule.
          Employees may only park in the garage to which they have been
          assigned. If an employee parks in a location other than their assigned
          one without prior authorization, posted daily parking fees will apply.
        </p>
      </span>
      {/* </td> */}
      {/* </tr> */}
      {/* <tr> */}
      {/* <td> */}
      <h6
        id="deduction"
        style={{
          textDecoration: 'underline',
          fontWeight: 'bold',
          marginBottom: 0,
        }}
      >
        Payroll Deductions
      </h6>
      <span style={{ fontSize: '16px' }}>
        <p>
          Money is withdrawn from the paychecks of NYP employees who choose to
          participate in the NYP payroll deduction program either weekly or
          biweekly, depending on the employee's pay cycle. Payroll, not the
          Parking Department, determines the pay periods. If an employee parks
          at least once within the 15 or 7-day parking period, the Parking
          Department will deduct the full period parking fee from the employee's
          paycheck.
        </p>
      </span>
      <h6
        id="pmt-methods"
        style={{
          textDecoration: 'underline',
          fontWeight: 'bold',
          marginBottom: 0,
        }}
      >
        Other Payment Methods
      </h6>
      <span style={{ fontSize: '16px' }}>
        <p>
          Employees may choose to opt out of the payroll deduction program and
          instead enroll in monthly billing. Those who select this option will
          receive a monthly invoice directly from the parking operator and are
          required to pay the full amount within the first five business days of
          the month. Additionally, employees may enroll in automated credit or
          debit card payment programs offered by the parking operator. Please
          note that NYP does not provide or manage these automated payment
          options.
        </p>
      </span>
      {/* </td>
          <td> */}
      <h6
        id="non-employee"
        style={{
          textDecoration: 'underline',
          fontWeight: 'bold',
          marginBottom: 0,
        }}
      >
        Non-Employees Policy
      </h6>
      <span style={{ fontSize: '16px' }}>
        <p>
          Contractors, travel nurses and vendors must be approved by the Parking
          Operation Director before applying for a parking account.
        </p>
      </span>
      {/* </td>
          <td> */}
      <h6
        id="cancellationId"
        style={{
          textDecoration: 'underline',
          fontWeight: 'bold',
          marginBottom: 0,
        }}
      >
        Account Cancellation
      </h6>
      <span style={{ fontSize: '16px' }}>
        <p>
          If the employee wishes to discontinue their monthly parking account,
          they have to notify the Parking Office. The Parking Department does
          not monitor employee parking use, and it is up to the employee to
          notify the Parking Department if they no longer need parking. Refunds
          are issued only if the Parking Department is informed of the account
          cancellation and fails to stop collection. Click{' '}
          <span style={{ fontWeight: 'bold' }}>
            <a href="https://app.smartsheet.com/b/form/6fe537dde0794a30ac39536e0ccd3a5a">
              here
            </a>
          </span>{' '}
          to access the online cancellation form and cancel an account.
        </p>
      </span>

      {/* </td>
          <td> */}
      <h6
        id="act-changes"
        style={{
          textDecoration: 'underline',
          fontWeight: 'bold',
          marginBottom: 0,
        }}
      >
        Account Changes
      </h6>
      <span style={{ fontSize: '16px' }}>
        <p>
          Employees are responsible for notifying the parking office of any
          changes to their parking accounts or vehicle information. This
          includes updating the employee's address, contact details, vehicle
          information, campus, and shifts. Please keep in mind that campus and
          shift changes may result in being added to the waiting list and/or a
          change of location. Employees are assigned to specific locations
          depending on available space, technological capabilities, and garage
          rules and guidelines. Click{' '}
          <span style={{ color: 'blue', fontSize: '16px', fontWeight: 'bold' }}>
            <a href="https://app.smartsheet.com/b/form/3e25fe741ade4a9587749f1c9c87cdae">
              here
            </a>
          </span>{' '}
          to access the online account information change from.
        </p>
      </span>
      <span style={{ fontSize: '16px' }}>
        <h6
          id="contactsId"
          style={{
            textDecoration: 'underline',
            fontWeight: 'bold',
            marginTop: 10,
            marginBottom: 0,
          }}
        >
          Below is a list of the Parking Department contact information
        </h6>
        <div style={{ display: 'inline-flex' }}>
          <p style={{ textAlign: 'start', fontSize: 14, marginRight: 25 }}>
            Columbia Campus Email:
            <br />
            <a href="mailto:parkingnyp-west@nyp.org">parkingnyp-west@nyp.org</a>
            <br />
            Parking Office: 212-305-4903
            <br />
            Manager Office: 212-305-2718
          </p>

          <p
            style={{
              textAlign: 'start',
              fontSize: 14,
              marginRight: 25,
            }}
          >
            Lower Manhattan Email:
            <br />
            <a href="mailto:parkingnyp-west@nyp.org">parkingnyp-west@nyp.org</a>
            <br />
            <a href="mailto:parkingnyp-east@nyp.org">parkingnyp-east@nyp.org</a>
            <br />
            Garage Office: 212-602-9980
            <br />
            Garage Office: 212-602-9981
          </p>

          <p style={{ textAlign: 'start', fontSize: 14, marginRight: 25 }}>
            Cornell Campus Email:
            <br />
            <a href="mailto:parkingnyp-east@nyp.org">parkingnyp-east@nyp.org</a>
            <br />
            Parking Office: 212-746-7357
          </p>

          <p style={{ textAlign: 'start', fontSize: 14 }}>
            Methodist Campus Email:
            <br />
            <a href="mailto:parkingnyp-@nyp.org">parkingnyp-BMH@nyp.org</a>
            <br />
            Garage Office: 718-369-8185
            <br />
            CCH Garage Office: 929-470-9101
          </p>
        </div>
      </span>
      {/* </td>
        </tr>
      </tbody> */}
      {/* </table> */}
    </div>
  );
}
export default MainTable;
